import { render, staticRenderFns } from "./author-details-create.html?vue&type=template&id=74981fd5&scoped=true&"
import script from "./author-details-create.js?vue&type=script&lang=js&"
export * from "./author-details-create.js?vue&type=script&lang=js&"
import style0 from "./author-details-create.scss?vue&type=style&index=0&id=74981fd5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74981fd5",
  null
  
)

export default component.exports